import { useTrackFirstTimeDepositFromDepositInfo } from 'hooks/analytics/useTrackFirstTimeDeposit';
import { useTrackTradeData } from 'hooks/analytics/useTrackTrade';
import { useUserTracking } from 'hooks/analytics/useUserTracking';

const AnalyticsTrackingIndia = () => {
  useUserTracking();
  useTrackTradeData();
  useTrackFirstTimeDepositFromDepositInfo();

  return null;
};

export { AnalyticsTrackingIndia };
